import React from 'react';
import { ChatBubbleLeftIcon } from '@interstate/components/Icons/ChatBubbleLeftIcon';
import { Typography } from '@interstate/components/Typography';
import { Grid } from '@interstate/components/Grid';
import { Box } from '@interstate/components/Box';
import { Tooltip } from '@interstate/components/Tooltip';
import { StyledTruncateText } from './OfferMessage.style.interstate';

export interface IOfferMessageProps {
    shopperMessage?: string;
    dealerMessage?: string;
    offerSource?: string;
}

export const OfferMessage: React.FC<IOfferMessageProps> = ({ shopperMessage, dealerMessage, offerSource }: IOfferMessageProps) => {
    const isOfferSourceDealer = offerSource?.toLowerCase() === 'dealmaker';
    const getMessage = () => (isOfferSourceDealer ? dealerMessage : shopperMessage);

    return (
        <Grid data-testid="offer-message" display={'flex'} gap={1} wrap={'nowrap'} alignItems={'center'}>
            <Box flexShrink={0} display={'inline-flex'}>
                <ChatBubbleLeftIcon data-testid="chat-icon" />
            </Box>

            <Tooltip position="bottom" size="lg" toolTipContent={`${getMessage() || '--'}`}>
                <StyledTruncateText>
                    <Typography variant="body-xxs" tag="span" data-testid="offer-message-text">
                        {getMessage() || '--'}
                    </Typography>
                </StyledTruncateText>
            </Tooltip>
        </Grid>
    );
};
